import SecureElementViewModel from "@/models/security/zorgID/secureElementViewModel";

export default class SessionOpenedViewModel {
  public SessionId!: string;
  public Status?: string;
  public IsCancelled?: boolean;
  public CancelledReason?: number;
  public SecureElement!: SecureElementViewModel;
}
